import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getCountryAwardWinners,
  getWinnerOrganization,
} from './index';

export const createWinnersApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getWinnerOrganization: (instance: IPublicClientApplication, winnerId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getWinnerOrganization(fetchContext, winnerId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getWinnerOrganization', isInFlight);
    },
  ),
  getCountryAwardWinners: (instance: IPublicClientApplication, programId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryAwardWinners(fetchContext, programId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryAwardWinners', isInFlight);
    },
  ),
});